import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { IOptions } from '../types'

export const OPTIONS: IOptions[] = [
  {
    id: 720,
    label: 'HD 720',
    description: translate(T.EXPORT_DESCRIPTION_720)
  },
  {
    id: 1080,
    label: 'HD 1080',
    description: translate(T.EXPORT_DESCRIPTION_1080)
  }
  // {
  //   id: 2160,
  //   label: 'UHD 4K',
  //   description: translate(T.EXPORT_DESCRIPTION_2160)
  // }
]
